// extracted by mini-css-extract-plugin
export default {"wrap":"Md4Zoi","link":"G7UFgx","color__primary":"spg3k0","color__secondary":"knycN3","size__m":"ngbgfy","size__l":"mQdGBF"};